import { Check } from '@on3/ui-lib/components/Svg';

import styles from './JoinRivals.module.scss';

const images = [
  {
    src: 'https://on3static.com/static/join/join-rivals-1.png?v=3',
    alt: 'Rivals Recruiting Screenshot 1',
    caption: 'In-depth recruiting analysis and rankings',
  },
  {
    src: 'https://on3static.com/static/join/join-rivals-2.png?v=3',
    alt: 'Rivals Recruiting Screenshot 2',
    caption: 'Get the latest in industry recruiting rankings and news',
  },
  {
    src: 'https://on3static.com/static/join/join-rivals-3.png?v=3',
    alt: 'Rivals Recruiting Screenshot 3',
    caption: 'Explore player profiles, rankings, and more',
  },
];

const bullets = [
  'The Original Recruiting Brand',
  'Team Recruiting Rankings',
  'Player Rankings',
  'High School Scores and Rankings',
  'Insider Reporting and Scoops',
];

export const JoinRivals = () => {
  return (
    <section className={styles.block}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2>Rivals Recruiting</h2>
          <p>
            The most trusted recruiting brand in the game, led by Steve
            Wiltfong, Chad Simmons, Joe Tipton, and more.
          </p>
        </header>
        <div className={styles.content}>
          <ul className={styles.bullets}>
            {bullets.map((b, i) => (
              <li className={styles.bullet} key={i}>
                <Check />
                {b}
              </li>
            ))}
          </ul>
          <div className={styles.images}>
            {images.map(({ src, alt, caption }) => (
              <figure className={styles.imageWrapper} key={src}>
                <img alt={alt} src={src} />
                <figcaption className="sr-only">{caption}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
